var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0003 24C11.1755 24 10.4688 23.7068 9.88217 23.1195C9.29409 22.5314 8.99987 21.8248 8.99987 21H15.001C15.001 21.8248 14.7071 22.5314 14.1205 23.1195C13.5317 23.7068 12.8254 24 12.0003 24ZM14.0002 3.00004C16.7935 3.79204 18.6477 6.22128 19.0005 9.03153L20.0003 17.0001H23.0005V20.0002H1V17.0001H3.99991L4.99969 9.03153C5.35247 6.22058 7.20633 3.79168 10 2.99969V0H13.9998L14.0002 3.00004Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotifications);
export default __webpack_public_path__ + "static/media/icon_notifications.794905b4e821d0ca75a5ae9ceee44f29.svg";
export { ForwardRef as ReactComponent };